<template>
  <v-list-tile @click="open">
    <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'plus']"></font-awesome-icon></v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>連絡先を追加する</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action class="text-xs-right">
      <v-btn flat :disabled="true"></v-btn>
    </v-list-tile-action>
    <v-dialog scrollable v-model="config.status.active" max-width="600">
      <v-card>
        <v-card-title class="grey lighten-3 blue-grey--text text--darken-4">
          <span class="headline">連絡先の追加</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md class="pa-0">
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-layout wrap>
                <v-flex xs12 sm3>
                  <v-select required
                    v-model="form.type"
                    label="連絡先の種類"
                    item-text="label"
                    item-value="value"
                    :items="getContactItems"
                    :rules="rules.type"></v-select>
                </v-flex>
                <v-flex xs12 sm9>
                  <v-text-field
                    v-model="form.contact"
                    :label="currentInputLabel"
                    :rules="currentInputRules"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="grey lighten-3">
          <v-btn flat
            color="blue darken-2"
            @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed
            color="blue darken-2 white--text"
            :loading="isLoading"
            :disabled="!isValid"
            @click="submit">追加する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-tile>
</template>

<script>
export default {
  name: 'insert-modal',
  data () {
    return {
      config: {
        status: {
          active: false
        }
      },
      meta: {
        contacts: {
          labels: {
            phone: '電話番号',
            mobile: '電話番号',
            email: 'メールアドレス'
          }
        }
      },
      form: {
        valid: true,
        type: '',
        contact: ''
      },
      rules: {
        type: [
          v => !!v || '必須項目です'
        ],
        phone: [
          v => !!v || '必須項目です',
          v => !/[^0-9]/.test(v) || '数字のみ入力有効です'
        ],
        mobile: [
          v => !!v || '必須項目です',
          v => !/[^0-9]/.test(v) || '数字のみ入力有効です'
        ],
        email: [
          v => !!v || '必須項目です',
          v => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(v) || '妥当なEメールではありません'
          }
        ]
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        type: '',
        contact: ''
      })
    },
    open: function () {
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.axios.post(this.$url.api + 'user/about/insert/contact', {
          type: this.form.type,
          contact: this.form.contact
        }, {
          headers: {
            'user-token': this.$localStorage.get('jwt')
          }
        }).then(res => {
          console.log(res)
          if (res.data && res.data.success) {
            this.$emit('emit', {
              action: 'insert',
              data: res.data.data
            })
          }
          this.$set(this.config.status, 'loading', false)
          this.$set(this.config.status, 'active', false)
        })
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    currentInputLabel () {
      return this.meta.contacts.labels[this.form.type] ? this.meta.contacts.labels[this.form.type] : '連絡先'
    },
    currentInputRules () {
      return this.rules[this.form.type] ? this.rules[this.form.type] : []
    },
    getContactItems () {
      return Object.keys(this.$meta.contacts).map(key => {
        return {
          value: key,
          label: this.$meta.contacts[key]
        }
      })
    }
  }
}
</script>
